export const GRAPHQL_URL = 'https://organic-mammal-65.hasura.app/v1/graphql'
